module.exports = __webpack_public_path__ + "static/img/BG-TRACK.00b524e2.jpg";